module.exports = __webpack_public_path__ + "static/img/02.918e272.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/k_mueller/02.jpg
// module id = 409
// module chunks = 1